import * as React from 'react'

import styled from '@emotion/styled'

import { getArcadeLinkStyles } from '../../styles'
import { typography } from '../../theme'
import Buttonless from '../Buttonless/Buttonless'
import Text from '../Text/Text'

export type ArcadeLinkButtonProps = {
  ariaLabel: string
  typography?: keyof Pick<typeof typography, 'linkMedium' | 'linkSmall'>
  onClick: () => void
  'data-testid'?: string
}

const ButtonLinkContainer = styled(Buttonless)`
  ${props => getArcadeLinkStyles(props.theme)}
  line-height: 0; /* stylelint-disable-line @cash-web/no-hardcoded-font-styles */
  min-height: 0;
  width: fit-content;
`

const ArcadeLinkButton: React.FC<React.PropsWithChildren<ArcadeLinkButtonProps>> = ({
  ariaLabel,
  typography = 'linkMedium',
  children,
  onClick,
  'data-testid': dataTestId,
}) => (
  <ButtonLinkContainer aria-label={ariaLabel} onClick={onClick} data-testid={dataTestId} type="button">
    <Text as="span" typography={typography}>
      {children}
    </Text>
  </ButtonLinkContainer>
)

export default ArcadeLinkButton
